import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Switch, Route} from 'react-router-dom';
import Settings from './scenes/Settings/';


class Profile extends Component {

    render() {
        return (
            <Switch>
                <Route path={'/profile/settings'} component={Settings}/>
            </Switch>
        );
    }
}

const mapStateToProps = state => ({
});


export default  connect(
    mapStateToProps
)(Profile);



// WEBPACK FOOTER //
// ./src/scenes/Profile/index.js